export const JETSTREAM_SERVER_EU = 'https://matchmaker.eu-west-1-web-streaming.avp.tech';
export const JETSTREAM_SERVER_US = 'https://matchmaker.us-west-2-web-streaming.avp.tech';

export const ACCESSORIES_MIN_VISIBLE_ITEMS = 18;
export const CMS_DEFAULT_HIDE_STANDARD_ACCESSORIES = true;
export const CMS_DEFAULT_STOCKCAR_PRICE_MIN = 10000;
export const CMS_DEFAULT_STOCKCAR_PRICE_MAX = 200000;
export const CMS_DEFAULT_STOCKCAR_GEOFILTER = false;
export const CMS_DEFAULT_STOCKCAR_SUBHEADER = false;
export const CMS_DEFAULT_STOCKCAR_DISCLAIMER = true;
export const CMS_DEFAULT_STOCKCAR_PRICE_DISCLAIMER = true;
export const CMS_DEFAULT_STOCKCAR_RANGE_MIN = 0;
export const CMS_DEFAULT_STOCKCAR_RANGE_MAX = 50;
export const CMS_DEFAULT_STOCKCAR_RANGE_STEP = 10;
export const CMS_DEFAULT_STOCKCAR_MODELPRECISION_CODE_PRECISION = 4;
export const CMS_DEFAULT_STOCKCAR_MODELPRECISION_START = -2;
export const CMS_DEFAULT_STOCKCAR_MODELPRECISION_END = 1;
export const MATCHES_PER_ROW = 2;
export const MATCH_ROWS = 2;

export const BREAKPOINT_GALLERY_IMAGE_SIZES = {
	small: {
		sm: 640,
		md: 1080,
		lg: 1540,
	},
	large: {
		sm: 1080,
		md: 1540,
		lg: 1920,
	},
};
